import { render, staticRenderFns } from "./subjectC.vue?vue&type=template&id=48a14436&"
import script from "./subjectC.vue?vue&type=script&lang=js&"
export * from "./subjectC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports